<template>
  <div>
    <div class="tooltip" v-if="history[currentStep].field.tooltip">
      <span class="icon icon-info-line"><info-icon/></span>
      <p class="tooltip-text" v-html="history[currentStep].field.tooltip">
      </p>
    </div>
    <section id="feeds-block" class="mobile-2-in-row" style="height: auto !important;">
      <div class="container">
        <div class="list-cont">
          <div v-for="(offer, index) in lenders"
               :key="index"
               :class="{'feeds-block__item-wrap': offer.type !== 'adsense', 'feed-ads': offer.type === 'adsense'}">
            <div v-if="offer.type !== 'adsense'" class="feeds-block__item">
              <div class="feeds-block__item-link">
                <!-- img -->
                <div class="feeds-block__item-img">
                  <img :src="offer.img" alt="">
                </div>
                <div class="feeds-block__item-content">
                  <!-- tags -->
                  <div class="feeds-block__item-tags">
                    <div v-if="offer.first_loan_free" class="feeds-block__item-tags__tag zero"><p>{{offer['first_loan_free_text']}}</p></div>
                    <div v-if="offer.car_pledge" class="feeds-block__item-tags__tag car"><p>{{offer['car_pledge_text']}}</p></div>
                    <div v-if="offer.is_card" class="feeds-block__item-tags__tag card"><p>{{offer['card_text']}}</p></div>
                    <div v-if="offer.is_bank" class="feeds-block__item-tags__tag bank"><p>{{offer['bank_text']}}</p></div>
                    <div v-if="offer.additional" class="feeds-block__item-tags__line"><p>{{offer['additional']}}</p></div>
                  </div>
                  <p class="feeds-block__item-content__title">{{offer.amout_title}}</p>
                  <p class="feeds-block__item-content__amount">{{offer.amout_body}}</p>
                </div>
                <!-- button -->
                <div class="feeds-block__item-button">
                  <a @click="processOfferClick(offer)" :href="offer.link" target="_blank" class="btn-lead">
                    <button>
                      <span>{{offer.buttonText}}</span>
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <ins v-else class="adsbygoogle feed-ads-ins"
                 style="display:block;"
                 :data-ad-client="offer.dataAdClient"
                 :data-ad-slot="offer.dataAdSlot"
                 :data-ad-format="offer.dataAdFormat"
                 data-full-width-responsive="true">
            </ins>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'

export default {
  name: 'ManualProcessFeed',
  components: { InfoIcon },
  data () {
    return {
      inputVal: null
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      config: state => state.config,
      lenders: state => state.manualProcessLenders,
      excludedLenders: state => state.excludedLenders
    })
  },
  mounted () {
    console.log('manual process feed is mounted')
    this.$store.dispatch('updateNONAPI').then(() => {
      this.$store.dispatch('prepareManualProcess')
    }, reason => {
      // cant update (empty list), so use sl-rpc list which was loaded after page loaded
      this.$store.dispatch('prepareManualProcess')
    })
  },
  methods: {
    processOfferClick (lender) {
      if (lender.type === 'API') {
        this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { lender_id: lender.lender_id })
        this.$store.dispatch('getDataFromBackend', +1)
        console.log('API call')
      }
      setTimeout(() => this.$store.commit('EXCLUDE_LENDER', lender.lender_id), 1000)
    }
  },
  watch: {
    lenders: function (val) {
      if (!val.length) this.$store.dispatch('goToOffers')
    }
  }
}
</script>

<style lang="scss">
//@import "../../assets/scss/offers.scss";
.list-cont {
  display: flex;
}
#feeds-block {
  width: 100vw;
  position: relative;
  left: calc(-50vw + 50%);
}
.form-container {
  display: block;
  position: relative;
}
.feeds-block__item-content {
  min-height: 81px;
}
</style>



// WEBPACK FOOTER //
// src/components/fields/ManualProcessFeed.vue